<script lang="ts">
    import FormManager from "@lib/FormManager/FormManager";
    import FormManagerProvider from "@lib/FormManager/FormManagerProvider.svelte";

    import ReviewsFilterQuery from "../queries/ReviewsFilterQuery";
    import ReviewsFilterFormInputs from "./ReviewsFilterFormInputs.svelte";

    export let filterFormManager: FormManager;
    export let reviewsFilterQuery: ReviewsFilterQuery;

    const errors$ = filterFormManager.errors$;
    const filters$ = reviewsFilterQuery.reviewsFilter$;
    const selectedFilters$ = filterFormManager.selectValues();

    const filterSelectedFilters = (
        selectedFilters: Record<string, string | string[] | number | number[]>
    ) => {
        return Object.fromEntries(
            Object.entries(selectedFilters).filter(([_, value]) => {
                if (
                    value === null ||
                    value === "" ||
                    (Array.isArray(value) && value.length === 0)
                ) {
                    return false;
                }

                if (
                    typeof value === "object" &&
                    value !== null &&
                    "day" in value &&
                    "month" in value &&
                    "year" in value
                ) {
                    return (
                        value.day !== null ||
                        value.month !== null ||
                        value.year !== null
                    );
                }

                return true;
            })
        );
    };
</script>

<div class="gw-rv-listing-layout__filter">
    <FormManagerProvider formManager={filterFormManager}>
        <ReviewsFilterFormInputs
            filters={$filters$.data.customerFilters}
            errors={$errors$}
            namespace={"reviews.ReviewsProductPageWidget"}
            filterType="customerFilters"
            selectedFilters={filterSelectedFilters($selectedFilters$)}
            {filterFormManager}
        />

        <ReviewsFilterFormInputs
            filters={$filters$.data.productFilters}
            errors={$errors$}
            namespace={"reviews.ReviewsProductPageWidget"}
            filterType="productFilters"
            selectedFilters={filterSelectedFilters($selectedFilters$)}
            {filterFormManager}
        />
    </FormManagerProvider>
</div>

<style lang="postcss">
    :global(.gw-rv-filter_clear) {
        font-size: 1em;
        font-style: normal;
        line-height: 20px;
        color: #6d6e85;
        cursor: pointer;
    }
</style>
